// components/ProjectCorrectionDrawer.jsx
// import { useEffect } from 'react';
// import AddDrawer from '../components/AddDrawer';
import {} from // useGetItemsQuery,
// useUpdateItemMutation,
'../slices/simpleApiSlice';
import { Stack, Typography } from '@mui/material';
// import ManageSearchIcon from '@mui/icons-material/ManageSearch';

const CorrectionScreen = () => {
  // const [openDrawer, setOpenDrawer] = useState(false);
  // const [selectedRowId, setSelectedRowId] = useState(null);

  const queryUrl = `/api/correction/update-stages-from-histories`;

  // const queryUrl = `/api/correction/projects-for-correction`;
  // const { data, isLoading } = useGetItemsQuery({ url: queryUrl });
  // // const [updateCorrection] = useUpdateItemMutation();

  // useEffect(() => {
  //   console.log('data', data);
  // }, [data]);

  // const handleRowClick = (projectId) => {
  //   setSelectedRowId(projectId);
  //   setOpenDrawer(true);
  // };

  // const handleTypeSelected = async (selectedTypeId) => {
  //   console.log(
  //     'Выбрана воронка:',
  //     selectedTypeId,
  //     'для проекта:',
  //     selectedRowId,
  //   );

  //   try {
  //     // Авто-сохранение при выборе (стратегия 1)
  //     await updateCorrection({
  //       url: `/api/correction/update-stages/${selectedRowId}`,
  //       prevType: selectedTypeId,
  //     }).unwrap();

  //     refetch(); // список уменьшится
  //     setOpenDrawer(false);
  //     setSelectedRowId(null);
  //   } catch (error) {
  //     console.error('Ошибка сохранения:', error);
  //   }
  // };

  // if (isLoading) return <div>Загрузка...</div>;

  return (
    <Stack>
      <Typography variant='body1'>
        {/* Исправить воронки ({data?.total || 0} проектов) */}
        {queryUrl}
      </Typography>

      {/* Список проектов */}
      {/* <Stack gap='12px'>
        {data?.projects?.map((project) => (
          <Stack
            key={project._id}
            direction='row'
            justify='between'
            sx={{
              cursor: 'pointer',
              p: '10px',
              border: '1px solid #443f3f',
              '&:hover': { bgcolor: '#464141' },
            }}
            onClick={() => handleRowClick(project._id)}
          >
            <Stack gap='0px' flex={1}>
              <Typography variant='body1'>{project.title}</Typography>
              <Typography size='body2'>{project.description}</Typography>
              <Typography size='body2' color='gray'>
                Сейчас: <strong>{project.currentTypeTitle}</strong>| Этапов:{' '}
                {project.stages.length}
              </Typography>
            </Stack>

            <Button variant='secondary'>
              <ManageSearchIcon />
            </Button>
          </Stack>
        ))}
      </Stack> */}

      {/* Drawer со списком воронок */}
      {/* <AddDrawer
        open={openDrawer}
        onClose={() => {
          setOpenDrawer(false);
          setSelectedRowId(null);
        }}
        title='Выберите предыдущую воронку'
        addSlug='types' // slug для воронок Type
        filter={[]}
        existingIds={[]} // все воронки доступны
        onSelect={handleTypeSelected} // вызывается при выборе
        selectedProjectId={selectedRowId} // передаём контекст
      /> */}
    </Stack>
  );
};

export default CorrectionScreen;
